export default __webpack_public_path__ + "static/media/job_offer17_m.8023cf3e.jpg";